export const MAIN_SUBSCRIPTION_TEST_IDS = {
  // ─── Subscription Bar Section ───
  sectionContainer: 'main-subscription-section-container',
  form: 'main-subscription-form',
  icon: 'main-subscription-icon',
  title: 'main-subscription-title',
  subtitle: 'main-subscription-subtitle',

  // ─── Form Fields ───
  emailInput: 'main-subscription-email-input',
  emailError: 'main-subscription-email-error',
  subscribeButton: 'main-subscription-subscribe-btn',
  successMessage: 'main-subscription-success-message',
  offersInfo: 'main-subscription-offers-info',
} as const;
